import { useSelector } from "react-redux";

export const useChatState = () => useSelector((state) => state.chat || {});
